import script from "./MaintenanceView.vue?vue&type=script&lang=ts&setup=true"
export * from "./MaintenanceView.vue?vue&type=script&lang=ts&setup=true"

import "./MaintenanceView.vue?vue&type=style&index=0&id=377167b2&lang=scss"

const __exports__ = script;

export default __exports__